import React, {Component} from 'react';
import './index.css'

class BsyStructureSlide extends Component {
    state = {
        fields:[],
    }
    componentDidMount() {
        React.axios("/webhook/fields",{
            appId:this.props.data.appid,
            formId:this.props.data.formid,
            type:this.props.type,
        }).then((res)=>{
            let data = res.data.data;
            let JSONData = JSON.stringify(data,null, 4);
            this.setState({
                JSONData
            })
        })
    }
    render() {
        const {JSONData} = this.state
        return (
            <div className="BsyStructureSlide">
                <div className="logging">
                    <div className="structureCont">
                        <pre>
                            <code>
                                 {
                                     JSONData
                                 }
                            </code>
                        </pre>
                    </div>
                </div>
            </div>
        );
    }
}

export default BsyStructureSlide;